export default __webpack_public_path__ + "static/media/qr-code-placeholder-rectangle.f5c954ed.png";